// extracted by mini-css-extract-plugin
export var closeButton = "_3h-3";
export var header = "_3h-0";
export var link = "_3h-1";
export var retryButton = "_3h-2";